<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-building_bk.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">法人管理</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: id ? 'corporation' : 'home' }">戻る</router-link>
    </div>
    <div class="container">
      <table class="table">
        <tbody>
          <tr>
            <td colspan="2">
              <button type="button" class="btn btn-edit" @click="edit" v-show="allowEditingCorporation">
                編集
              </button>
              <button type="button" class="btn" @click="changePassword">
                パスワード変更
              </button>
            </td>
          </tr>
          <tr>
            <th scope="row" width="30%">法人ID</th>
            <td>{{ currentCorporation.uid }}</td>
          </tr>
          <tr>
            <th scope="row">法人名</th>
            <td>{{ currentCorporation.name }}</td>
          </tr>
          <tr>
            <th scope="row">法人名（フリガナ）</th>
            <td>{{ currentCorporation.nameReading }}</td>
          </tr>
          <tr>
            <th scope="row">郵便番号</th>
            <td>{{ currentCorporation.postalCode }}</td>
          </tr>
          <tr>
            <th scope="row">都道府県 市区町村</th>
            <td>{{ currentCorporation.state }}</td>
          </tr>
          <tr>
            <th scope="row">番地・建物名</th>
            <td>{{ currentCorporation.address }}</td>
          </tr>
          <tr>
            <th scope="row">電話番号</th>
            <td>{{ currentCorporation.phone }}</td>
          </tr>
          <tr>
            <th scope="row">FAX番号</th>
            <td>{{ currentCorporation.fax }}</td>
          </tr>
          <tr>
            <th scope="row">メールアドレス</th>
            <td>{{ currentCorporationEmail }}</td>
          </tr>
          <tr>
            <th scope="row">利用教材</th>
            <td>{{ currentCorporationProducts }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import store from '@/store/index.js';
import { basicPresent, basicProductName } from '@/presenters/fields';

export default {
  props: {
    id: {
      type: [String, Number],
      required: false,
    },
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch('corporation/fetchCorporation', routeTo.params.id).then(() => {
        next();
      });
    } else {
      next();
    }
  },
  mounted() {
    // 登録・編集の入力情報を初期化
    this.clearEditingCorporation();
  },
  computed: {
    currentCorporation() {
      return this.corporation.corporation;
    },
    currentCorporationEmail() {
      return basicPresent(this.currentCorporation.email);
    },
    currentCorporationProducts() {
      return basicProductName(this.currentCorporation.figuredProducts);
    },
    ...mapState(['corporation']),
    ...mapGetters('role', ['allowEditingCorporation']),
  },
  methods: {
    edit() {
      if (this.id) {
        this.$logger.debug('Edit Corporation ID ' + this.id);
        this.$router.push({ name: 'corporation-id-edit', params: { id: this.id } });
      }
    },
    changePassword() {
      if (this.id) {
        this.$logger.debug('Change Password ID ' + this.id);
        this.$router.push({ name: 'corporation-id-change-password', params: { id: this.id } });
      } else {
        this.$logger.debug('Change Password');
        this.$router.push({ name: 'corporation-change-password' });
      }
    },
    ...mapActions('corporation', ['clearEditingCorporation']),
  },
};
</script>

<style scoped>
.btn {
  margin-left: 0px;
}
.btn-edit {
  margin-right: 20px;
}
</style>
